import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl } from 'src/utils/helper'

const AboutUsSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.about_us')}
      </Typography.Title>
      <a href={`${baseUrlShopify}/pages/who-we-are`}>
        {t('common:footer.about_us.who_we_are')}
      </a>
      <a href={`${baseUrlShopify}/pages/how-we-design`}>
        {t('common:footer.about_us.how_design')}
      </a>
      <a href={`${baseUrlShopify}/pages/our-commitment-to-you`}>
        {t('common:footer.about_us.our_commit')}
      </a>
      <a href="https://fyihealthgroup.com/partnerships/">
        {t('common:footer.about_us.partnership')}
      </a>
      <a href={`${baseUrlShopify}/pages/careers`}>
        {t('common:footer.about_us.careers')}
      </a>
    </Space>
  )
}

export default AboutUsSection
